import apiClient from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useSetRecoilState } from 'recoil';
import { Dirary } from '../../../types/dirary';
export const useGetProcessees = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getProcesses = async (productNo: string, productBno: string) => {
    setLoadingAnimation(true);
    setLoadingText('検索中...');
    try {
      // const res = await axios.get(
      //   `https://kintoneconnect-6ywpmfhxlq-an.a.run.app/api/users/worker-info/${searchId}`
      // );
      // const res = await apiClient.get(
      //   `https://kinoneconnect-okdftkfcxq-an.a.run.app/api/users/worker-info/${searchId}`
      // );
      const res = await apiClient.get(
        `/rocketForge/processes/${productNo}/${productBno}`
      );

      const data = res.data;
      return data;
    } catch (e) {
      window.alert('エラーが発生しました' + e);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText('');
    }
  };
  const getProcessesFromDiaryList = async (diaryList: Dirary[]) => {
    const productNoList = extractUniquePairs(diaryList);
    if (!productNoList?.length) return null;

    //ここで、productNoListを使ってAPIを叩く
    // setLoadingAnimation(true);
    // setLoadingText("検索中...");
    try {
      // const res = await apiClient.get(`/rocketForge/processes/byProductList`, {
      //   params: {
      //     productNoList: productNoList,
      //   },
      // });
      const res = await apiClient.post('/rocketForge/processes/byProductList', {
        productNoList,
      });
      const data = res.data;
      return data;
    } catch (e) {
      window.alert('エラーが発生しました' + e);
      return null;
    } finally {
      // setLoadingAnimation(false);
      // setLoadingText("");
    }
  };
  const extractUniquePairs = (
    diaryList: Dirary[]
  ): { productNo: string; productBno: string }[] => {
    const uniquePairs = new Set<string>();
    const result: { productNo: string; productBno: string }[] = [];

    diaryList.forEach((diary) => {
      const pairKey = `${diary.productNo}-${diary.productBno}`;
      if (!uniquePairs.has(pairKey)) {
        uniquePairs.add(pairKey);
        result.push({
          productNo: diary.productNo,
          productBno: diary.productBno,
        });
      }
    });

    return result;
  };

  return { getProcesses, getProcessesFromDiaryList };
};
